const baseRoute = `${process.env.PUBLIC_URL}/`;
export const baseApi = "https://admin.darwenmosque.co.uk:8090/";

export const LOGIN_ROUTE = baseRoute;
